<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          variant="primary"
          @click="dialog"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }} </span>
        </b-button>
      </template>
    </app-breadcrumb>
    <!-- Filters -->
    <!-- Table Container Card -->
    <div class="card mb-1">
      <div class="card-body p-1">
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group class="mb-0">
              <b-input-group>
                <b-form-input
                  v-model="localSearchQuery"
                  class="d-inline-block"
                  placeholder="Tên thể loại"
                  @keyup.enter="updateSearchQuery"
                />
                <b-input-group-append>
                  <b-button
                    variant="primary"
                    @click="updateSearchQuery"
                  >
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <b-table
          ref="refUserListTable"
          class="articletype-relative"
          :items="dataItems"
          :fields="tableColumns"
          primary-key="id"
          responsive
          show-empty
          empty-text="Không tìm thấy kết quả"
        >
          <template #cell(name)="data">
            <span
              class="title"
              @click="edit(data.item)"
            ><b>{{ data.item.code }} - {{ data.item.name }}</b></span>
          </template>
          <template #cell(status)="data">
            <b-form-checkbox
              :checked="data.item.status == 1 ? true : false"
              class="custom-control-primary"
              name="check-button"
              switch
              @change="onStatus(data.item)"
            />
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="row">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="edit(row.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              v-if="$can('articleType.destroy', 'ArticleType')"
              size="sm"
              class="ml-1"
              variant="outline-danger"
              @click="confirmDelete(row.item.id)"
            >
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <b-modal
      id="modalState"
      ref="showModal"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      size="md"
      :title="title_modal"
      hide-footer
      @close="hidenModal"
    >
      <article-type-edit
        :data-edit="dataEdit"
        @updateList="handleDialog"
      />
    </b-modal>
  </div>
</template>

<script>

import {
  BOverlay, BCard, BRow, BCol, BButton, BTable, BFormCheckbox,
  BPagination, BModal, BFormGroup, BForm, BInputGroupAppend,
  BInputGroup, BFormInput,
} from 'bootstrap-vue'
import { ref, computed, watch } from '@vue/composition-api'
import { showToast } from '@/@core/utils/utils'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import store from '@/store';
import ArticleTypeEdit from './ArticleTypeEdit.vue'

export default {
  components: {
    AppBreadcrumb,
    BOverlay,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    BFormCheckbox,
    BModal,
    BFormGroup,
    BForm,
    ArticleTypeEdit,
    BInputGroupAppend,
    BInputGroup,
    BFormInput,
  },
  data() {
    return {
      textSubmit: 'Lưu',
      title_modal: 'Thêm mới',
      dataEdit: {},
    }
  },
  setup() {
    const refListTable = ref(null);
    const tableColumns = [
      {
        key: 'id', sortable: false, label: 'ID', thAttr: { width: '6%' },
      },
      { key: 'name', sortable: false, label: 'Thể loại' },
      {
        key: 'status',
        sortable: false,
        label: 'Trạng thái',
        thAttr: { width: '11%' },
      },
      {
        key: 'actions',
        label: 'Hành động',
        class: 'action',
        thAttr: { width: '6%' },
      },
    ];
    const perPage = ref(30);
    const total = ref(0);
    const currentPage = ref(1);
    const searchQuery = ref('');
    const loading = ref(true);
    const dataItems = ref([]);
    const localSearchQuery = ref('');

    const fetchAll = () => {
      store
        .dispatch('articletype/fetchAll', {
          keyword: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
        })
        .then((response) => {
          loading.value = false;
          const result = response.data;
          if (result.code === 200) {
            dataItems.value = result.data.data;
            total.value = result.data.data.total;
          }
        });
    };
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value
        ? refListTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      };
    });
    watch([currentPage, perPage, searchQuery], () => {
      refetchData();
    });
    const refetchData = () => {
      fetchAll();
    };

    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value;
    };
    fetchAll();
    return {
      total,
      loading,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      dataItems,
      localSearchQuery,
      updateSearchQuery,
      refetchData,
    }
  },
  methods: {
    hidenModal() {
      this.$bvModal.hide('modalState');
      this.dataEdit = {};
      this.refetchData();
    },
    handleDialog() {
      this.refetchData();
      this.$bvModal.hide('modalState');
    },
    dialog() {
      this.$bvModal.show('modalState')
    },
    edit(item) {
      this.dataEdit = item;
      this.title_modal = 'Cập nhật'
      this.$bvModal.show('modalState')
    },
    onStatus(itemView) {
      const { id } = itemView
      store.dispatch('articletype/status', { id })
        .then(response => {
          const result = response.data
          if (result.code === 200) {
            showToast(result.message, { variant: 'success' })
          } else {
            showToast(result.message)
          }
        })
        .catch(error => {

        })
    },
    confirmDelete(id) {
      this.$swal({
        title: 'Bạn chắc muốn xóa?',
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('articletype/destroy', { id }).then((res) => {
            if (res.status === 200) {
              this.refetchData();
              showToast(res.data.message, { variant: 'success' });
            } else {
              showToast(res.data.message);
            }
          })
        }
      })
    },
  },

}
</script>
